<template>
<div class="chapter">
<div class="inner_page">
<div class="wrap">
<p class="image"><a id="page_6"></a><img alt="image" class="vertical" src="images/f0006-01.jpg"/></p>
</div>
<div class="wrap">
<p class="image"><a id="page_7"></a><img alt="image" class="vertical" src="images/f0007-01.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06image01.vue?3e30738b